module.exports = __webpack_public_path__ + "img/vaccine.7ae17a47.svg";